package com.exura.features.plandefinition.data.remote.dto.element

import com.exura.features.firebase.data.remote.dto.SerializableDto
import kotlinx.serialization.Serializable

/**
 * Base Data Transfer Object for all plan element types.
 * Implements SerializableDto for Firebase storage compatibility.
 */
@Serializable
abstract class BasePlanElementDto : SerializableDto {
    abstract val elementType: String
    abstract val durationInMinutes: Int
    abstract val durationInDays: Int
    abstract val imageUrl: String?
}
